<template>
	<v-layout row wrap class="financial-large-row" style="page-break-inside: avoid">
		<v-flex d-flex xs1>
			<v-card tile :color=parseColorValue(firstCellColorIntesity) class="financial-table-header-color">
				<v-card-text class="financial-table-value-font-size">
					<strong>
						{{firstCellLabel}}
					</strong>
				</v-card-text>
			</v-card>
		</v-flex>

		<v-flex d-flex xs1 v-for="(value,index) in cellsValues" :key="index">
			<v-card tile :color=parseColorValue(cellsColorIntensity)>
				<v-card-text :style="cellTextStyle" class="financial-table-value-font-size">
					<span>{{cellsFormatter(value)}}</span>
				</v-card-text>
			</v-card>
		</v-flex>
	</v-layout>
</template>
<script>
	export default {
		name: 'FinancialSummaryLargeRow',

		computed: {
			cellTextStyle () {
				let style = "padding-left: 5px; padding-right: 5px;";
				if (this.textRight) {
					style += "text-align: right";
				}
				if (this.textCenter) {
					style += "text-align: center";
				}
				return style;
			}
		},

		methods: {
			parseColorValue(val) {
				if (val < 0) {
					return "grey darken-" + (-val);
				}
				return "grey lighten-" + val;
			}
		},

		props: {
			textCenter: {},
			textRight: {},
			firstCellLabel: {},
			firstCellColorIntesity: {},
			cellsValues: {},
			cellsFormatter: {},
			cellsColorIntensity: {}
		}
	};
</script>
